import React from "react";

import { ConnectedFetchVersionsController } from "./connected-fetch-versions-controller";

function withFetchVersionsController(Wrapped) {
  return class WithFetchVersionsController extends React.PureComponent {
    constructor() {
      super();

      this.fetchId = `versions-${Date.now()}`;
    }

    render() {
      // The fetchId is a hack to work with the existing implementation of
      // fetch controller. I don't want to refactor fetch controller for now
      // as I'm not sure what the implementation should look like.
      return (
        <ConnectedFetchVersionsController fetchId={this.fetchId}>
          <Wrapped {...this.props} />
        </ConnectedFetchVersionsController>
      );
    }
  };
}

export { withFetchVersionsController };
